import { render, staticRenderFns } from "./ExcluirAnexo.vue?vue&type=template&id=4202f45a&"
import script from "./ExcluirAnexo.vue?vue&type=script&lang=ts&"
export * from "./ExcluirAnexo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports